import React from "react";
import { Copy, CheckCircle } from "lucide-react";

const GeneratedLinkCard = ({ generatedLink, copied, copyToClipboard }) => {
  const formatExpiration = (iso) => new Date(iso).toLocaleString();

  return (
    <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <div>
          <h3 className="text-lg font-medium text-gray-800">Generated Link</h3>
          <p className="text-sm text-blue-600 font-medium">{generatedLink.build_info.name}</p>
          <p className="text-xs text-gray-500">{generatedLink.build_info.description}</p>
        </div>
        <span className="text-sm text-gray-500">Expires: {formatExpiration(generatedLink.expires_at)}</span>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="text"
          value={generatedLink.url}
          readOnly
          className="flex-1 px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-sm"
        />
        <button
          onClick={() => copyToClipboard(generatedLink.url)}
          className="px-3 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md transition-colors duration-200 flex items-center gap-1"
        >
          {copied === "single" ? <CheckCircle size={16} /> : <Copy size={16} />}
          {copied === "single" ? "Copied!" : "Copy"}
        </button>
      </div>
    </div>
  );
};

export default GeneratedLinkCard;
